import { Button, Form } from "antd";
import Table, { ColumnsType } from "antd/lib/table";
import { useNavigate } from "react-router-dom";

import { TableHelper } from "../../../util/TableHelper";
import { RouteConstants } from "../../../constants/ApplicationConstants/RouteConstants";

import type FixMeLater from "../../../shared/types/fixMeLater.type";

const ParkingOccupancyMonitoringTable = () => {
  const navigate = useNavigate();

  const handleCancel = () => {
    navigate(`${RouteConstants.DEFAULT_HOME_PAGE}`);
  };

  const dummydataStorage = [
    {
      sr_no: 1,
      tower_level: "L1"
    },
    {
      sr_no: 2,
      tower_level: "L2"
    },
    {
      sr_no: 3,
      tower_level: "L3"
    }
  ];

  const renderText = (text: FixMeLater) => {
    return <div className="wordWrapWordBreak">{TableHelper.getValue(text)}</div>;
  };

  const columnsStorage: ColumnsType<FixMeLater> = [
    {
      align: "right",
      title: "Sr No.",
      dataIndex: "sr_no",
      key: "sr_no",
      render: renderText,
      sorter: {
        compare: TableHelper.valueCompare("id")
      },
      width: "10%"
    },
    {
      align: "left",
      title: "Tower",
      dataIndex: "tower_level",
      key: "tower_level",
      render: renderText,
      sorter: {
        compare: TableHelper.valueCompare("tower_level")
      }
    },
    {
      align: "left",
      title: "Spot 1",
      dataIndex: "vehicle_Type",
      key: "vehicle_Type",
      render: renderText,
      sorter: {
        compare: TableHelper.valueCompare("vehicle_Type")
      }
    },
    {
      align: "left",
      title: "Spot 2",
      dataIndex: "location",
      key: "location",
      render: renderText,
      sorter: {
        compare: TableHelper.valueCompare("location")
      }
    },
    {
      align: "left",
      title: "Spot 2",
      dataIndex: "location",
      key: "location",
      render: renderText,
      sorter: {
        compare: TableHelper.valueCompare("location")
      }
    },
    {
      align: "left",
      title: "Spot 3",
      dataIndex: "location",
      key: "location",
      render: renderText,
      sorter: {
        compare: TableHelper.valueCompare("location")
      }
    },
    {
      align: "left",
      title: "Spot 4",
      dataIndex: "location",
      key: "location",
      render: renderText,
      sorter: {
        compare: TableHelper.valueCompare("location")
      }
    },
    {
      align: "left",
      title: "Spot 5",
      dataIndex: "location",
      key: "location",
      render: renderText,
      sorter: {
        compare: TableHelper.valueCompare("location")
      }
    },
    {
      align: "left",
      title: "Spot 6",
      dataIndex: "location",
      key: "location",
      render: renderText,
      sorter: {
        compare: TableHelper.valueCompare("location")
      }
    }
  ];

  return (
    <>
      <Table className="gx-table-responsive" columns={columnsStorage} dataSource={dummydataStorage} bordered rowKey={(record) => record.sr_no} />

      <Form.Item className="form-button form-button-pr ">
        <Button className="gx-mb-0 button-gradiant" onClick={handleCancel}>
          Cancel
        </Button>
      </Form.Item>
    </>
  );
};
export default ParkingOccupancyMonitoringTable;
